import * as React from "react";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { selectMarketImprovementInfo } from "../../selectors/selectMarketImprovementInfo";
import { GridContainer } from "../generic/grid-layout/GridContainer";
import { GridItemMarketImprovement } from "./GridItemMarketImprovement";
var _MasterViewMarketImprovement = function (_a) {
    var improvementItems = _a.improvementItems, onSelect = _a.onSelect;
    var _b = useState(0), selectedItemIndex = _b[0], setSelectedItemIndex = _b[1];
    useEffect(function () {
        onSelectImprovementItem(selectedItemIndex);
    }, [improvementItems[selectedItemIndex].level]);
    var onSelectImprovementItem = function (index) {
        var improvementItem = improvementItems[index];
        setSelectedItemIndex(index);
        if (onSelect) {
            onSelect(improvementItem);
        }
    };
    return (React.createElement("div", { className: "flex h100 w100" },
        React.createElement(GridContainer, { items: improvementItems, selectedIndex: selectedItemIndex, onSelect: onSelectImprovementItem, gridItemRenderer: GridItemMarketImprovement })));
};
var mapState = function (state) { return ({
    improvementItems: selectMarketImprovementInfo(state),
}); };
export var MasterViewMarketImprovement = connect(mapState)(_MasterViewMarketImprovement);



//////////////////
// WEBPACK FOOTER
// ./src/features/market/MasterViewMarketImprovement.tsx
// module id = 2708
// module chunks = 3